import { render, staticRenderFns } from "./InsuranceWithdrawal.vue?vue&type=template&id=0da3a0ff&scoped=true"
import script from "./InsuranceWithdrawal.vue?vue&type=script&lang=js"
export * from "./InsuranceWithdrawal.vue?vue&type=script&lang=js"
import style0 from "./InsuranceWithdrawal.vue?vue&type=style&index=0&id=0da3a0ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da3a0ff",
  null
  
)

export default component.exports